/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { PageApi } from "../clients";
import { wrap } from "../wrap";

export const pageApi = {
  deletePage: wrap(PageApi, PageApi.prototype.deletePage),
  getPage: wrap(PageApi, PageApi.prototype.getPage),
  getPageById: wrap(PageApi, PageApi.prototype.getPageById),
  getPageServiceById: wrap(PageApi, PageApi.prototype.getPageServiceById),
  postPageCopy: wrap(PageApi, PageApi.prototype.postPageCopy),
  getPageTemplateById: wrap(PageApi, PageApi.prototype.getPageTemplateById),
  getThanksPage: wrap(PageApi, PageApi.prototype.getThanksPageTemplateById),
  postCreatePage: wrap(PageApi, PageApi.prototype.postCreatePage),
  putPageTemplate: wrap(PageApi, PageApi.prototype.putPageTemplate),
  putPageName: wrap(PageApi, PageApi.prototype.putPageName),
  putPageStatus: wrap(PageApi, PageApi.prototype.putPageStatus),
  putPageSecretFlag: wrap(PageApi, PageApi.prototype.putPageSecretFlag),
  putPageSecretPassword: wrap(PageApi, PageApi.prototype.putPageSecretPassword),
  getListTemplatePage: wrap(PageApi, PageApi.prototype.getListTemplatePage),
  getDetailTemplatePage: wrap(PageApi, PageApi.prototype.getDetailTemplatePage),
};
